import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import TechLifePhoto from '../TechLifePhoto.svg';

const CheckoutLogoPreview = ({ logo }: { logo?: string | File | undefined | null }) => {
  return (
    <Box
      sx={{
        width: { md: '312px', xs: '100%' },
        maxWidth: '312px',
        height: '261px',
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: '24px',
        display: 'flex',
        flexDirection: 'column',
        backgroundColor: 'secondary.light',
        px: 2,
        pt: 2,
      }}
    >
      <Stack spacing={3} sx={{ height: '100%' }}>
        <Typography variant="medium" fontWeight="bold">
          Preview
        </Typography>
        <Box
          sx={{
            border: '1px solid',
            borderColor: 'grey.300',
            backgroundColor: 'white',
            px: 2,
            pt: 2,
            height: '100%',
            borderBottom: 'none',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box sx={{ mb: 2 }}>
            {logo ? (
              <img
                data-testid="partner-logo"
                style={{ width: '64px', height: '64px' }}
                src={typeof logo === 'string' ? logo : URL.createObjectURL(logo)}
                alt="Partner Logo"
              />
            ) : (
              <img
                data-testid="placeholder-logo"
                style={{ width: '64px', height: '64px' }}
                src={TechLifePhoto}
                alt="PlaceholderLogo"
              />
            )}
          </Box>
          <Box
            sx={{
              border: '2px solid',
              borderColor: 'grey.300',
              height: '40px',
              borderTopLeftRadius: '24px',
              borderTopRightRadius: '24px',
            }}
          />
          <Box
            sx={{
              border: '2px solid',
              borderColor: 'grey.300',
              borderTop: 'none',
              borderBottom: 'none',
              flexGrow: 1,
              px: 2,
            }}
          >
            <Typography variant="medium" fontWeight="bold" sx={{ pt: 1.5, opacity: 0.4 }}>
              Checkout
            </Typography>
          </Box>
        </Box>
      </Stack>
    </Box>
  );
};

export default CheckoutLogoPreview;
